<template>
  <div
    class="page_container companyDetailPage"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/mine' }">我的</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/companyIndex/companyList' }"
          >加入企业or团队</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ userCompanyCard.qyname }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <!-- <h1>{{userCompanyCard.qyname}}</h1> -->
      <div class="content_wrap flex-between">
        <div class="company_intro">
          <div class="block flex-rowl logo_tit">
            <div class="logo flex-rowc">
              <el-image :src="userCompanyCard.logo" fit="contain">
                <div slot="error" class="image-slot flex-rowc">
                  <i class="iconfont icon-zanwutupian1"></i>
                </div>
              </el-image>
            </div>
            <div class="content">
              <p>
                企业名称：<span>{{
                  userCompanyCard.qyname ? userCompanyCard.qyname : ""
                }}</span>
              </p>
              <p>
                企业名称英文/缩写：<span>{{
                  userCompanyCard.qyename ? userCompanyCard.qyename : ""
                }}</span>
              </p>
            </div>
          </div>
          <div class="block">
            <p>
              联系人：<span>{{
                userCompanyCard.linkname ? userCompanyCard.linkname : ""
              }}</span>
            </p>
            <p>
              联系电话：<span>{{
                userCompanyCard.linkphone ? userCompanyCard.linkphone : ""
              }}</span>
            </p>
            <p>
              联系邮箱：<span>{{
                userCompanyCard.linkemail ? userCompanyCard.linkemail : ""
              }}</span>
            </p>
            <p>
              社会统一信用代码：<span>{{
                userCompanyCard.uscc ? userCompanyCard.uscc : ""
              }}</span>
            </p>
          </div>
          <div class="block">
            <p>
              官方抖音ID：<span>{{
                userCompanyCard.douyinid ? userCompanyCard.douyinid : ""
              }}</span>
            </p>
            <p>
              官方小红书ID：<span>{{
                userCompanyCard.redbookid ? userCompanyCard.redbookid : ""
              }}</span>
            </p>
            <p>
              官方大众点评ID：<span>{{
                userCompanyCard.dianpingid ? userCompanyCard.dianpingid : ""
              }}</span>
            </p>
          </div>
          <div class="block">
            <p>
              所在地区：<span>{{ userCompanyCard.cityArea }}</span>
            </p>
            <p>
              详细地址：<span>{{ userCompanyCard.addr }}</span>
            </p>
          </div>
        </div>
        <div class="company_operation flex-cowl" v-if="!loading">
          <div v-if="userCompanyCard.checkstate == '审核中'">
            <div class="txt">
              <p>已经申请加入，待审核</p>
              <p>申请时间：{{ userCompanyCard.checkdate }}</p>
            </div>
            <div class="primary-button-plain" @click="handleCancelApply">
              取消加入申请
            </div>
          </div>
          <div v-else-if="userCompanyCard.checkstate == '已通过'">
            <div class="txt">
              <p>已加入</p>
            </div>
            <div class="primary-button-plain" @click="handleExit">退出企业</div>
          </div>
          <div v-else-if="userCompanyCard.checkstate == '拒绝加入'">
            <div class="txt">
              <p>拒绝加入</p>
            </div>
            <div class="primary-button" @click="handleApply">重新申请加入</div>
          </div>
          <div class="primary-button" @click="handleApply" v-else>申请加入</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Clipboard from "clipboard";
import { encryptstringview } from "../../api/api";
import {
  getCompanyInfo,
  applyAddCompany,
  cancelApply,
  userExitCompany,
} from "../../api/company";
export default {
  name: "companyDetail",
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      loading: false,
      isOperation: false,
      userCompanyCard: {},
      cityArea: "",
      qyid: "",
    };
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { qyid } = JSON.parse(res.jsondata);
        this.qyid = qyid;
        this.getCompanyInfo();
      } else {
        this.$router.back();
      }
    },

    getCompanyInfo() {
      let { qyid } = this;
      let userInfo = this.$store.state.USERINFO;
      this.loading = true;
      getCompanyInfo({ qyid, openid: userInfo.openid }).then((res) => {
        res.logo =
          res.logo.indexOf("http") != -1 ? res.logo : this.baseUrl + res.logo;
        this.userCompanyCard = res;
        let provincename = res.provincename ? res.provincename : "";
        let cityname = res.cityname ? res.cityname : "";
        let arearname = res.arearname ? res.arearname : "";
        this.cityArea = provincename + cityname + arearname;
        this.loading = false;
      });
    },

    // 申请加入
    handleApply() {
      let { userCompanyCard } = this;
      let userInfo = this.$store.state.USERINFO;
      this.loading = true;
      let params = {
        qyid: userCompanyCard.id,
        accountid: userInfo.accountid,
        openid: userInfo.openid,
        truename: userInfo.truename,
        mobile: userInfo.mobile,
        deptid: "",
        roleid: "",
      };
      applyAddCompany(params).then((res) => {
        if (res.result) {
          // this.$message.success(res.message);
          this.getCompanyInfo();
          // this.loading = false;
        } else {
          this.$message.error(res.message || "服务器报错，请稍后～");
          this.loading = false;
        }
      });
    },

    // 取消申请
    handleCancelApply() {
      let { userCompanyCard } = this;
      this.loading = true;
      let userInfo = this.$store.state.USERINFO;
      let params = {
        qyid: userCompanyCard.id,
        openid: userInfo.openid,
      };
      cancelApply(params).then((res) => {
        if (res.result) {
          // this.$message.success(res.message);
          this.getCompanyInfo();
          // this.loading = false;
        } else {
          this.$message.error(res.message || "服务器报错，请稍后～");
          this.loading = false;
        }
      });
    },

    // 退出企业
    handleExit() {
      this.loading = true;
      let { userCompanyCard, OPENID } = this;
      let params = {
        qyid: userCompanyCard.id,
        openid: OPENID,
      };
      userExitCompany(params).then((res) => {
        if (res.result) {
          // this.$message.success(res.message);
          this.getCompanyInfo();
        } else {
          this.$message.error(res.message || "服务器报错，请稍后～");
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.companyDetailPage {
  .form_container {
    height: 68vh;
  }
  .company_intro {
    width: 48%;
    flex-shrink: 0;
    margin-right: 5%;
    .block {
      margin-bottom: 25px;
    }
    p {
      color: #404d6c;
    }
    .logo_tit {
      align-items: flex-start;
      .logo {
        width: 100px;
        height: 100px;
        margin-right: 20px;
        background: #fff;
        .icon-zanwutupian1 {
          font-size: 40px;
        }
      }
    }
  }
  .company_operation {
    flex: 1;
    .txt {
      margin-bottom: 30px;
      font-size: 18px;
      color: #444;
      p {
        line-height: 30px;
      }
    }
  }
}
</style>